import { ConfigService, ApiConfigService, type Tuple } from '@nextgen-web-framework/core';
interface LoginState {
  headers: Tuple;
  redirectUri: string;
  loginUrl?: string;
  amwayLang?: string;
}

export const getLoginProps = (currentLocale: string) => {
  const tuples = ApiConfigService.getTuples();
  const configs = ConfigService.getConfigs();
  let postAuthUrl = '';
  if (typeof window !== 'undefined') {
    const loginState: LoginState = {
      redirectUri: window.location.href,
      headers: tuples,
      amwayLang: currentLocale,
    };
    if (configs.NEXT_PUBLIC_LOGIN_URL) {
      loginState.loginUrl = configs.NEXT_PUBLIC_LOGIN_URL as string;
    }
    postAuthUrl = btoa(JSON.stringify(loginState));
  }
  return {
    scope: 'openid',
    state: postAuthUrl,
    countryIso: tuples['X-Amway-Country'],
    redirectUri: configs.NEXT_PUBLIC_OIDC_URL ? `${configs.NEXT_PUBLIC_OIDC_URL}` : '',
  };
};

export const getLogoutProps = () => {
  const configs = ConfigService.getConfigs();
  const baseUrl = ApiConfigService.getBaseUrl();

  const postAuthUrl = btoa(JSON.stringify({ redirectUri: `${configs.NEXT_PUBLIC_WEB_BASE_PATH}/logout` }));
  const postLogoutRedirectUri = `${baseUrl}/comgluuoidc/v1/logout?state=${postAuthUrl}`;
  return {
    postLogoutRedirectUri: postLogoutRedirectUri,
  };
};
